import {useUserProfile} from '#/hooks/query/use-user-profile';
import {getShortAccountAddress} from '#/utils/account-utils';
import {UserProfile} from 'shareland-common';
import {Hex} from 'viem';
import {useEnsName} from 'wagmi';

type UseUserDisplayNameParams = {account: Hex | undefined; userProfile?: UserProfile};
export const useUserDisplayName = (params: UseUserDisplayNameParams): {data: string; isLoading: boolean} => {
  const {account, userProfile} = params;

  const enabled = !userProfile?.displayName;

  const {data: apiUserProfile, isLoading: isApiUserProfileLoading} = useUserProfile({
    account,
    enabled,
  });
  const {data: ensDisplayName, isLoading: isEnsDisplayNameLoading} = useEnsName({
    address: account,
    chainId: 1,
    query: {
      enabled: enabled && !apiUserProfile?.displayName && !isApiUserProfileLoading,
    },
  });

  const userProfileDisplayName = userProfile?.displayName !== '' ? userProfile?.displayName : null;
  const apiUserProfileDisplayName = apiUserProfile?.displayName !== '' ? apiUserProfile?.displayName : null;

  const data =
    userProfileDisplayName ??
    apiUserProfileDisplayName ??
    ensDisplayName ??
    (account ? getShortAccountAddress(account) : '');
  const isLoading = enabled && (isApiUserProfileLoading || isEnsDisplayNameLoading);

  return {
    data,
    isLoading,
  };
};
